import { faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppDispatch, useAppSelector } from "Redux/hooks";
import {
  addComment,
  askToDelete,
  changeChapterOrderNumber,
  changeComment,
  changeQuestionOrderNumber,
  findConditionToChange,
  setQuestionValue,
} from "feature/producer/actions";
import debounce from "lodash.debounce";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Chapter, Question } from "types/type.module";
import { TextElement } from "types/types";
import RichTextTranslator from "../../Logic/RichTextTranslator";
import {
  addChapterToBackend,
  addQuestionToBackend,
  changeChapterInBackend,
  changeQuestionInBackend,
  selectCurrentChapter,
  selectCurrentModule,
  selectProducerNewBeEvents,
  selectShowAddElement,
} from "../../Redux/ProducerSlice";
import AddButton from "../Atoms/AddButton";
import Button from "../Atoms/Button";
import ElementLable from "../Atoms/ElementLabel";
import { CompleteEditor } from "../Molecule/MinimalEditor";
import { selectStyle } from "Redux/appSlice";

export default function StepSelector({
  chapterIndex,
  chapter,
  onSelect,
  onAdd,
  onChapterChange,
  onQuestionChange,
  onAddQuestion,
  createQuestionSnapshot,
}: {
  chapter: Chapter;
  chapterIndex: number;
  onSelect: (question: Question) => void;
  onAdd: () => void;
  onChapterChange: (
    value: string,
    orderNumber: number,
    chapterId: string,
    frontChapterId: string
  ) => void;
  onQuestionChange: (
    orderNumber: number,
    // value: { type: ElementTag; content: StepContent[] },
    value: any,
    questionId?: string
  ) => void;
  onAddQuestion: (type: string, orderNumber: number) => void;
  createQuestionSnapshot: (question: Question) => void;
}) {
  const { color4 } = useAppSelector(selectStyle);
  const currentModule = useAppSelector(selectCurrentModule);
  const newBeEvents = useAppSelector(selectProducerNewBeEvents);
  const currentChapter = useAppSelector(selectCurrentChapter);
  const showAddElement = useAppSelector(selectShowAddElement);
  const [showQuestions, setShowQuestions] = useState(
    chapter.chapter_id === currentChapter
  );
  const dispatch = useAppDispatch();
  const params = useParams();
  const { orgId = "", moduleId = "" } = params;
  const [chapterName, setChapterName] = useState(
    chapter.name === null ? "" : chapter.name
  );
  let index = 0;
  currentModule?.chapters.forEach((c, i) =>
    c.order_number === chapter.order_number ? (index = i) : null
  );

  const frontChapterId = chapter.frontChapterId || "";

  const debounceChapter = useCallback(
    debounce((e: ChangeEvent<HTMLInputElement>) => {
      onChapterChange(
        e.target.value,
        chapter.order_number,
        chapter.chapter_id || "",
        chapter.frontChapterId || ""
      );
    }, 200),
    [chapter.chapter_id, chapter.frontChapterId, chapter.order_number]
  );

  useEffect(() => {
    setChapterName(chapter.name || "");
  }, [chapter.name]);

  if (!currentModule) return null;

  return (
    <div className="flex flex-col items-center justify-start">
      <div className="border border-2 border-black rounded-full bg-transparent w-3/5 p-4 flex justify-between">
        <ElementLable chapter={chapter.order_number} />
        <input
          className=" bg-transparent w-3/5 "
          type="text"
          min="0"
          value={chapterName}
          onChange={(e) => {
            debounceChapter(e);
            setChapterName(e.target.value);
          }}
        />
        <input
          className="w-12 h-12"
          type="number"
          min="1"
          max={currentModule.chapters.length}
          value={chapter.order_number}
          onChange={(e) => {
            dispatch(
              changeChapterOrderNumber({
                order_number: parseInt(e.target.value, 10),
                chapterId: chapter.chapter_id,
                frontChapterId: frontChapterId,
                oldOrderNumber: chapter.order_number,
              })
            );
          }}
        />
        <div
          className={`flex  justify-between ${
            newBeEvents[frontChapterId] ? "w-48" : "w-22"
          }`}
        >
          {newBeEvents[frontChapterId] && newBeEvents[frontChapterId].event == "post" && (
            <Button
              onClick={() =>
                dispatch(
                  addChapterToBackend({
                    orgId,
                    moduleId,
                    frontChapterId: frontChapterId,
                    order_number: chapter.order_number,
                    name: chapterName || "",
                  })
                )
              }
              label="SAVE"
            />
          )}
          {chapter.chapter_id &&
            newBeEvents[chapter.chapter_id] && newBeEvents[chapter.chapter_id].event == "patch" &&
            JSON.stringify(newBeEvents[chapter.chapter_id].snapshot) !==
              JSON.stringify(chapter) && (
              <Button
                onClick={() =>
                  dispatch(
                    changeChapterInBackend({
                      orgId,
                      moduleId,
                      chapterId: chapter.chapter_id || "",
                      order_number: chapter.order_number,
                      name: chapterName || "",
                    })
                  )
                }
                label="SAVE"
              />
            )}
          <button
            className="cursor-pointer "
            onClick={() => setShowQuestions(!showQuestions)}
          >
            {showQuestions ? <ZoomOut /> : <ZoomIn />}
          </button>
          <button
            className=""
            onClick={() => {
              dispatch(
                askToDelete({
                  element: "chapter",
                  chapterId: chapter.chapter_id,
                  frontChapterId: frontChapterId,
                })
              );
            }}
          >
            <FontAwesomeIcon icon={faMinus} size="2x" />
          </button>
        </div>
      </div>
      <div className="overflow-y-auto overflow-x-hidden w-3/5 mt-5 ">
        {showQuestions && showAddElement && (
          <div className="mx-24">
            <button
              className="border border-2 border-black rounded-full p-4  mt-2 w-full"
              onClick={() => onAddQuestion("question", 1)}
            >
              add question
            </button>
          </div>
        )}
        {showQuestions &&
          currentModule.chapters[chapterIndex].questions.map((q, i) => {
            let content = q.content;
            if (typeof q.content === "string") {
              content = JSON.parse(q.content);
              if (typeof content === "string") {
                content = JSON.parse(content);
                if (typeof content === "string") {
                  content = JSON.parse(content);
                }
              }
            }

            return (
              <div key={i} className="my-4 mx-24">
                <div
                  className="border border-2 rounded-full p-4 flex flex-row justify-start xl:justify-between flex-start"
                  style={{ borderColor: color4 }}
                >
                  <ElementLable
                    chapter={chapter.order_number}
                    question={q.order_number}
                    conclusion={q.conclusion}
                  />
                  <CompleteEditor
                    text={
                      typeof content !== "string" && "text" in content
                      ? {
                            type: "doc",
                            content: RichTextTranslator({
                              text: content.text as TextElement,
                            }),
                          }
                        : content
                    }
                    className="w-44 2xl:w-96"
                    onUpdate={(val) => {
                      onQuestionChange(q.order_number, val, q.question_id);
                    }}
                    elementAskingRerender={[q.order_number, q.question_id]}
                    element={{ chapter: index, question: i }}
                  />
                  <input
                    className="w-12 h-12"
                    type="number"
                    value={q.order_number}
                    min="1"
                    max={
                      currentModule
                        ? currentModule.chapters[chapterIndex].questions.length
                        : 0
                    }
                    onChange={(e) => {
                      dispatch(
                        changeQuestionOrderNumber({
                          order_number: parseInt(e.target.value, 10),
                          questionId: q.question_id,
                          frontQuestionId: q.frontQuestionId,
                          oldOrderNumber: q.order_number,
                        })
                      );
                    }}
                  />
                  {q.comment !== undefined && q.comment !== null && (
                    <textarea
                      className="border border-black"
                      defaultValue={q.comment}
                      onChange={debounce(
                        (val: ChangeEvent<HTMLTextAreaElement>) =>
                          dispatch(
                            changeComment({
                              comment: val.target.value,
                              chapterIndex: chapterIndex,
                              questionIndex: i,
                            })
                          ),
                        200
                      )}
                    />
                  )}

                  <div className="flex flex-col">
                    {q.conclusion && (
                      <div>
                        <label>hidden</label>
                        <input
                          type="checkbox"
                          checked={q.should_be_hidden}
                          onChange={(e) => {
                            dispatch(
                              setQuestionValue({
                                value: e.target.checked,
                                valueName: "should_be_hidden",
                                questionId: q.question_id,
                                frontQuestionId: q.frontQuestionId,
                              })
                            );
                          }}
                        />
                      </div>
                    )}
                    <div>
                      <label>conclusion</label>
                      <input
                        type="checkbox"
                        checked={q.conclusion}
                        onChange={(e) => {
                          dispatch(
                            setQuestionValue({
                              value: e.target.checked,
                              valueName: "conclusion",
                              questionId: q.question_id,
                              frontQuestionId: q.frontQuestionId,
                            })
                          );
                        }}
                      />
                    </div>
                    {!q.conclusion && (
                      <div>
                        <label>multiple</label>
                        <input
                          type="checkbox"
                          checked={q.multiple}
                          onChange={(e) => {
                            dispatch(
                              setQuestionValue({
                                value: e.target.checked,
                                valueName: "multiple",
                                questionId: q.question_id,
                                frontQuestionId: q.frontQuestionId,
                              })
                            );
                          }}
                        />
                      </div>
                    )}
                    {q.conclusion && (
                      <div>
                        <label>print</label>
                        <input
                          type="checkbox"
                          checked={q.print}
                          onChange={(e) => {
                            dispatch(
                              setQuestionValue({
                                value: e.target.checked,
                                valueName: "print",
                                questionId: q.question_id,
                                frontQuestionId: q.frontQuestionId,
                              })
                            );
                          }}
                        />
                      </div>
                    )}
                    {(q.comment === undefined || q.comment === null) && (
                      <Button
                        label="ADD COMMENT"
                        onClick={() => {
                          dispatch(
                            addComment({
                              chapterIndex: chapterIndex,
                              questionIndex: i,
                            })
                          );
                        }}
                      />
                    )}
                  </div>
                  <div
                    className={`flex justify-between ${
                      newBeEvents[q.frontQuestionId || ""] ? "w-46" : "w-24"
                    } `}
                  >
                    {newBeEvents[q.frontQuestionId || ""] && (
                      <Button
                        onClick={() =>
                          dispatch(
                            addQuestionToBackend({
                              orgId,
                              frontQuestionId: q.frontQuestionId || "",
                              order_number: q.order_number,
                              content: q.content,
                              chapter_id: chapter.chapter_id || "",
                              conclusion: q.conclusion,
                              display_index: q.order_number,
                              multiple: q.multiple,
                              print: q.print,
                              should_be_hidden: q.should_be_hidden,
                              ...(q.comment && { comment: q.comment }),
                              trigger: {},
                            })
                          )
                        }
                        label="SAVE"
                      />
                    )}
                    {newBeEvents[q.question_id || ""] &&
                      (newBeEvents[q.question_id || ""].snapshot !==
                        JSON.stringify(createQuestionSnapshot(q)) ||
                        newBeEvents[q.question_id || ""].elementModified) && (
                        <Button
                          onClick={() =>
                            dispatch(
                              changeQuestionInBackend({
                                orgId,
                                questionId: q.question_id || "",
                                order_number: q.order_number,
                                content: q.content,
                                chapterId: chapter.chapter_id,
                                conclusion: q.conclusion,
                                guidances: [],
                                examples: [],
                                displayId: q.display_index,
                                multiple: q.multiple,
                                print: q.print,
                                should_be_hidden: q.should_be_hidden,
                                trigger: q.trigger,
                                ...(q.comment && { comment: q.comment }),
                                newBeEvents: newBeEvents,
                              })
                            )
                          }
                          label="SAVE"
                        />
                      )}
                    <button
                      onClick={() => {
                        onSelect(q);
                      }}
                    >
                      <Continue />
                    </button>
                    <button
                      className=""
                      onClick={() => {
                        if (q.conclusion) {
                          dispatch(
                            findConditionToChange({
                              chapter: q.chapter_id,
                              question: q.question_id,
                            })
                          );
                        }
                        dispatch(
                          askToDelete({
                            element: "question",
                            questionId: q.question_id || "",
                            frontQuestionId: q.frontQuestionId,
                          })
                        );
                      }}
                    >
                      <FontAwesomeIcon icon={faMinus} size="2x" />
                    </button>
                  </div>
                </div>
                {showAddElement && (
                  <button
                    className="border border-2 border-black rounded-full p-4 w-full mt-2"
                    onClick={() =>
                      onAddQuestion("question", q.order_number + 1)
                    }
                  >
                    add question
                  </button>
                )}
              </div>
            );
          })}
      </div>
      {showAddElement && (
        <AddButton
          onClick={() => {
            onAdd();
          }}
          isAbsolute={false}
        />
      )}
    </div>
  );
}

const ZoomIn = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="40" width="40">
      <path d="M32.833 34.292 22.125 23.583q-1.25 1.084-2.896 1.667t-3.396.583q-4.25 0-7.208-2.937-2.958-2.938-2.958-7.146 0-4.25 2.958-7.188 2.958-2.937 7.167-2.937 4.208 0 7.166 2.937 2.959 2.938 2.959 7.188 0 1.75-.605 3.396-.604 1.646-1.687 2.937L34.333 32.75ZM15.792 23.75q3.375 0 5.687-2.333 2.313-2.334 2.313-5.667 0-3.375-2.313-5.708-2.312-2.334-5.687-2.334-3.334 0-5.688 2.334Q7.75 12.375 7.75 15.75q0 3.333 2.354 5.667 2.354 2.333 5.688 2.333Zm-1.042-3.708V16.75h-3.292v-2.083h3.292v-3.25h2.083v3.25h3.25v2.083h-3.25v3.292Z" />
    </svg>
  );
};

const ZoomOut = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="40" width="40">
      <path d="M32.833 34.292 22.125 23.583q-1.25 1.084-2.896 1.667t-3.396.583q-4.25 0-7.208-2.937-2.958-2.938-2.958-7.146 0-4.25 2.958-7.188 2.958-2.937 7.167-2.937 4.208 0 7.166 2.937 2.959 2.938 2.959 7.188 0 1.75-.605 3.396-.604 1.646-1.687 2.937L34.333 32.75ZM15.792 23.75q3.375 0 5.687-2.333 2.313-2.334 2.313-5.667 0-3.375-2.313-5.708-2.312-2.334-5.687-2.334-3.334 0-5.688 2.334Q7.75 12.375 7.75 15.75q0 3.333 2.354 5.667 2.354 2.333 5.688 2.333Zm-4-7v-2.083h7.958v2.083Z" />
    </svg>
  );
};

const Continue = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="40" width="40">
      <path d="m20 32.708-1.458-1.5 10.125-10.166H7.292v-2.084h21.375L18.542 8.792 20 7.292 32.708 20Z" />
    </svg>
  );
};
